import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-winlose-detail-esports',
  templateUrl: './winlose-detail-esports.component.html',
  styleUrls: ['./winlose-detail-esports.component.scss'],
})
export class WinloseDetailEsportsComponent implements OnInit, OnChanges {
  @Input() DetaileSports: any;
  constructor() {}

  ngOnInit() {}
  ngOnChanges() {}
}
